<div class="p-5">
  <div *ngIf="isLoading" class="space-y-3 mt-4">
    <div
      *ngFor="let i of [1, 2, 3, 4, 5]"
      class="flex items-start gap-6 p-4 border border-gray-200 rounded-xl bg-white dark:bg-coal-500 mb-4"
    >
      <!-- LEFT SECTION -->
      <div class="flex flex-col gap-3 flex-1 min-w-0">
        <!-- Code + Title -->
        <div class="flex items-center gap-3">
          <div
            class="w-20 h-4 bg-gray-300 dark:bg-coal-400 rounded shimmer-item"
          ></div>
          <div
            class="w-40 h-4 bg-gray-300 dark:bg-coal-400 rounded shimmer-item"
          ></div>
        </div>

        <!-- Badges -->
        <div class="flex items-center gap-3">
          <div
            class="w-12 h-6 bg-gray-300 dark:bg-coal-400 rounded-full shimmer-item"
          ></div>
          <div
            class="w-20 h-6 bg-gray-300 dark:bg-coal-400 rounded-full shimmer-item"
          ></div>
          <div
            class="w-16 h-6 bg-gray-300 dark:bg-coal-400 rounded-full shimmer-item"
          ></div>
          <div
            class="w-16 h-6 bg-gray-300 dark:bg-coal-400 rounded-full shimmer-item"
          ></div>
          <div
            class="w-16 h-6 bg-gray-300 dark:bg-coal-400 rounded-full shimmer-item"
          ></div>
          <div
            class="w-16 h-6 bg-gray-300 dark:bg-coal-400 rounded-full shimmer-item"
          ></div>
        </div>
      </div>

      <!-- RIGHT SECTION -->
      <div class="flex items-start gap-4 flex-1 min-w-0">
        <!-- Description -->
        <div class="flex flex-col gap-2 flex-1 min-w-0">
          <div
            class="w-full h-4 bg-gray-300 dark:bg-coal-400 rounded shimmer-item"
          ></div>
          <div
            class="w-5/6 h-4 bg-gray-300 dark:bg-coal-400 rounded shimmer-item"
          ></div>
        </div>

        <!-- Avatar -->
        <div
          class="w-9 h-9 rounded-full bg-gray-300 dark:bg-coal-400 shimmer-item shrink-0"
        ></div>
      </div>
    </div>
  </div>

  <div class="space-y-4 cardBody" *ngIf="!isLoading">
    <!-- No Data -->
    <div
      class="flex justify-center items-center"
      *ngIf="formData?.records == null"
    >
      <div
        class="py-8 text-gray-500 text-sm font-medium flex flex-col items-center"
      >
        <app-no-data-view></app-no-data-view>
      </div>
    </div>

    <!-- View -->
    <div
      class="border border-gray-500 rounded-xl p-4 cursor-pointer hover:bg-secondary-active mb-4 bg-white dark:bg-coal-500"
      *ngFor="let item of formData?.records"
      (click)="onCardClick($event, item)"
    >
      <div class="row align-items-center gy-2">
        <!-- LEFT SECTION (ID + Title + Badges + Progress) -->
        <div class="col-12 col-md-6 col-lg-6 d-flex gap-3">
          <!-- Checkbox -->
          <div class="flex items-center" *ngIf="taskAssigned == ''">
            <input
              type="checkbox"
              class="checkbox text-blue-600 cursor-pointer"
              [id]="'option_' + item._id"
              [checked]="isSelected(item)"
              (click)="onRowSelect(item, $event)"
            />
          </div>
          <div class="flex-grow-1">
            <!-- Task ID + Title -->
            <div class="d-flex align-items-start gap-2 flex-wrap">
              <span class="font-medium text-default-primary text-sm break-all">
                {{ item.taskId }}
              </span>

              <span class="font-semibold text-gray-800 text-sm">
                {{ item.control }}
              </span>
            </div>

            <!-- Badges -->
            <div class="d-flex flex-wrap gap-1 mt-2">
              <!-- Domain -->
              <span
                *ngIf="
                  item.domainSubdomainMappings &&
                  item.domainSubdomainMappings?.[0].domain != ''
                "
                class="badge badge-sm badge-outline rounded-full badge-info cursor-default"
              >
                {{ item.domainSubdomainMappings?.[0].domain }}
              </span>

              <!-- Subdomain -->
              <span
                *ngIf="
                  item.domainSubdomainMappings &&
                  item.domainSubdomainMappings?.[0].subdomain != ''
                "
                class="badge badge-sm badge-outline rounded-full badge-success cursor-default"
              >
                {{ item.domainSubdomainMappings?.[0].subdomain }}
              </span>

              <!-- Priority -->
              <span
                class="cursor-default custom-badge badge badge-sm badge-outline rounded-full text-nowrap h-[30px] w-[100px] text-center"
                [ngClass]="getBadgeClass('priority', getPriority(item.priority))"
              >
                {{ getPriority(item.priority) }}
              </span>

              <!-- Risk -->
              <span
                class="cursor-default custom-badge badge badge-sm badge-outline rounded-full text-nowrap h-[30px] w-[100px] text-center"
                [ngClass]="getBadgeClass('risk', item.risk)"
              >
                {{ item.risk || "Low" }}
              </span>

              <!-- Status -->
              <span
                class="cursor-default custom-badge badge badge-sm badge-outline rounded-full text-nowrap h-[30px] w-[100px] text-center"
                [ngClass]="getBadgeClass('status', item.status)"
              >
                {{ item.status }}
              </span>
            </div>

            <!-- Progress -->
            <!-- <div class="d-flex align-items-center gap-2 mt-2">
            <small class="text-gray-600 font-normal text-sm">Progress:</small>

            <div class="progress flex-grow-1" style="height: 6px">
              <div
                class="progress-bar"
                [ngClass]="{
                  'bg-success': item.progress >= 70,
                  'bg-warning': item.progress >= 40 && item.progress < 70,
                  'bg-danger': item.progress < 40,
                }"
                role="progressbar"
                [style.width.%]="item.progress"
              ></div>
            </div>

            <small class="fw-semibold text-muted"> {{ item.progress }}% </small>
          </div> -->
          </div>
        </div>

        <!-- Task Description -->
        <div class="col-12 col-md-5 col-lg-5">
          <div class="text-sm text-break text-gray-600 font-normal">
            {{ item.description }}
          </div>
        </div>

        <!-- Assignee -->
        <div
          class="col-12 col-sm-12 col-md-1 col-lg-1 flex items-center justify-center"
          *ngIf="taskAssigned == ''"
        >
          <div
            *ngIf="item.assigned != ''"
            class="relative group mx-auto w-7 h-7 rounded-full text-sm font-bold uppercase border-2 border-white cursor-pointer overflow-hidden"
            (click)="assignUsers(item); $event.stopPropagation()"
          >
            <!-- Initials with department background -->
            <div
              [ngClass]="getBgColorByDepartment(item?.assigned)"
              class="w-full h-full flex items-center justify-center group-hover:hidden text-white"
            >
              {{ getInitials(item?.assigned) }}
            </div>

            <!-- Edit Icon on hover -->
            <div
              class="absolute inset-0 hidden group-hover:flex items-center justify-center bg-transparent"
            >
              <i
                class="ki-outline ki-notepad-edit text-gray-600 transition duration-200"
              ></i>
            </div>
          </div>

          <ng-container *ngIf="item.assigned == ''">
            <div *ngIf="item.assigned == ''" class="flex -space-x-2">
              <div
                class="z-0 w-7 h-7 rounded-full border-2 border-white flex items-center justify-center cursor-pointer overflow-hidden addUser mx-auto"
                (click)="assignUsers(item); $event.stopPropagation()"
              >
                <img
                  src="./assets/media/icons/user-add.svg"
                  class="w-15px h-15px opacity-80 z-0"
                />
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- View More -->
<div
  class="text-center mb-5"
  *ngIf="
    formData?.records != null && formData?.hasNextPage == true && !isLoading
  "
>
  <a
    (click)="viewMore()"
    class="btn btn-link text-sm font-medium hover:underline mb-5"
  >
    View More
  </a>
</div>

<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  id="assign_modal"
>
  <div class="modal-content bg-white dark:bg-coal-500">
    <div class="modal-header pr-2.5">
      <span class="text-base font-semibold card-title">
        {{ modalTitle }}
      </span>
      
    </div>
    <div class="modal-body grid gap-5 px-0" *ngIf="activeModalContext">
      <!-- (keydown.enter)="onEnterPressed($event)" -->
      <app-modal-renderer
        *ngIf="activeModalContext"
        #modalRendererRef
        [nodeId]="activeModalContext.nodeId"
        (header)="setModalTitle($event)"
        (closeModal)="closeModal()"
        [taskId]="activeModalContext.taskId"
        (formSaved)="onModalFormSaved($event)"
        [activeModalContext]="activeModalContext"
      ></app-modal-renderer>
    </div>
  </div>
</div>
